import ConfirmationDialog from '@/ui/components/ConfirmationDialog.vue';

const plugin = (app, globalOptions = {}) => {
  const openConfirmation = function(options) {
    let content;
    if (typeof options === 'string') {
      content = options;
    }

    const defaultOptions = {
      content,
    };

    const propsData = Object.assign({}, defaultOptions, globalOptions, options);

    // 'this' is the Vue component instance when called as this.$confirmation.open()
    if (!this.$fullscreenModal) {
      // eslint-disable-next-line no-console
      console.error('ConfirmationModal: $fullscreenModal not available');
      return null;
    }

    return this.$fullscreenModal.open(
      this,
      ConfirmationDialog,
      propsData,
      {
        center: true,
        closable: false,
        closeWithOutclick: false,
      },
    );
  };

  Object.defineProperty(app.config.globalProperties, '$confirmation', {
    get() {
      return {
        open: openConfirmation.bind(this),
      };
    },
  });
};

/* eslint-disable-next-line local-rules/custom-naming-pattern */
const ConfirmationModal = { install: plugin };

export { ConfirmationModal, ConfirmationModal as default };
